<script>
  import {Bar} from 'vue-chartjs'

  export default {
    watch: {
       dashboardLoaded(value) {
         if (value) {
           this.$data._chart.update()
           this.renderChart(this.chartdata, this.options)
         }
       }
    },
    props: {
      dashboardLoaded: {
        type:Boolean,
        default:false
      },
      chartdata: {
        type: Object,
        default: null
      },
      options: {
        type: Object,
        default: null
      }
    },
    name: "ChartBar",

    extends: Bar,
    mounted() {
      /**Customize the Rectangle.prototype draw method**/

      this.renderChart(this.chartdata, this.options)


    }
  }
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';

  canvas {
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      width: 100% !important;

    }
  }
</style>



// WEBPACK FOOTER //
// src/Charts/ChartBar.vue